module.exports = __webpack_public_path__ + "static/img/lombardy-region.f933f50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/partners/lombardy-region.jpg
// module id = mw6x
// module chunks = 1